module.exports = __webpack_public_path__ + "img/camera.4e2bf47a.svg";